import { cache } from 'react';
import { clearUndefinedValues } from 'utils/object';
import { interpolate } from 'utils/string';

const API_URL = process.env.NEXT_PUBLIC_API_URL;

interface RequestOptions extends RequestInit {
  url: string;
  query?: Record<string, any>;
  params?: Record<string, any>;
  tags?: string[];
}

export const queryTenantApi = cache(
  async (tenant: string, { url: path, method = 'GET', headers, query, tags, params = {}, ...rest }: RequestOptions) => {
    const url = new URL(interpolate(path, params), API_URL);

    const clearedQuery = query && clearUndefinedValues(query);
    if (clearedQuery && Object.keys(clearedQuery).length) {
      url.search = new URLSearchParams(clearedQuery).toString();
    }

    const response = await fetch(url, {
      method,
      headers: {
        ...headers,
        'Content-Type': 'application/json',
        ['x-ref-tenant']: tenant,
      },
      next: { tags },
      ...rest,
    });

    return await response.json();
  },
);
